import { IMarker } from './../../../shared/components/map/map.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultsContainer, HotelPreview } from './../results.container';
import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation, } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { HotelHeaderInfo } from '../../../core/store/general/state';
import { experiencesIconsMapping } from '../../../core/models/results/experienceMapping.model';
import { Angulartics2 } from 'angulartics2';
import { ResultsService } from '../../../core/services/results.service';
import { ChangeLasteRequestAsked } from '../../../core/store/general/actions';
import { SharedContainer } from '../../../shared/shared.container';
import { Meta } from '@angular/platform-browser';
import { NgxUsefulSwiperModule, SwiperComponent } from 'ngx-useful-swiper';
import { SwiperOptions } from 'swiper';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { CancellationPolicy } from '../../../core/models/results/cancellation-policy.model';

declare const fbq: any;
export enum RoomMode {
    WITH_CANCELLATION = 1,
    NON_REFUNDABLE = 2,
    BOTH = 3
}
@Component({
    selector: 'app-hotel-single',
    templateUrl: 'hotel-single.component.html',
    styleUrls: ['hotel-single.component.css', 'hotel-single.component.scss'],
    encapsulation: ViewEncapsulation.None,
    preserveWhitespaces: false,
})

export class HotelSingleComponent implements OnInit, NgxUsefulSwiperModule {

    @ViewChild('usefulSwiperMobile', { static: false }) usefulSwiperMobile: SwiperComponent;
    @ViewChild('ruoOverview', { static: false }) ruoOverview: ElementRef;

    swiperRealIndex: Number = 1;
    config: SwiperOptions;

    showSummary: Boolean = false;

    // initialization for experiences
    experiencesMappingRest = [
        { id: 7, name: 'Love to explore the local cuisine', checked: false, position: 1 },
        { id: 35, name: 'Looking for pet-friendly accommondation', checked: false, position: 2 },
        { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
        { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
        { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
        { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
        { id: 15, name: 'Wanting a workspace, got some work to do', checked: false, position: 7 },
        { id: 4, name: 'Want to spend precious time with my family', checked: false, position: 8 },
        { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
        { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
        { id: 20, name: 'Would love to be transfered from and to the airport', checked: false, position: 11 },
        { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
        { id: 13, name: 'Host our guests and/or our wedding party', checked: false, position: 13 },
        { id: 8, name: 'Want to experience the local way of life', checked: false, position: 14 },
        { id: 24, name: 'Want to explore the landmarks, sites and local history ', checked: false, position: 15 },
        { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
        { id: 2, name: 'I want to enjoy the warm sun and the golden beaches', checked: false, position: 17 },
        { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
    ];

    images = [];

    appLogo = '../../../../../assets/img/logo-home-vervendo.svg';

    offerInfo;
    offerId;
    hotelName;
    tabHeaderInfo: TabHeaderInfo;
    hotelDscription: HotelDescription;
    facilitiesTab: FacilitiesTabInfo;
    locations: LocationTabInfo;
    roomOffers: Array<RoomInfo>;
    markers = new Array<IMarker>();
    mapCenter = { latitude: 0, longitude: 0 };
    hotels = new Array<HotelPreview>();
    experiencesDate = new Map();

    guests: number;
    carouselDate: string;

    selectedRoomTypes = new Map();
    mealtypes = new Set<string>();
    experiencesList = new Set<string>();
    requestForSearch;
    roomsForBooking = new Map();
    offerNote;
    hotelierIcon;
    hotelierName;
    currentTotalCost = 0;
    public selectedExperiences = new Array();
    hotelInfo;
    isTextHighlighted = false;

    mobileFullsreenWindow = {
        isSortByOpen: false,
        isFilterOptionsOpen: false,
        isMapOpen: false
    };
    loading = false;

    formattedFromDate: any;
    formattedToDate: any;

    isOffer: boolean;
    isMapDesktopOpen: Boolean = false;

    satisfiedWishes: Map<Number, String>;
    finalWishes: Map<String, Boolean>;
    selectedExps: Map<Number, String>;
    totalSatisfied: number;

    expiresInDays: String;
    expiresInHours: String;
    expiresInMinutes: String;

    bestDiscount = {
        discountUp: true,
        oldPrice: 0,
        newPrice: 0,
        discount: 0
    };

    selections: Array<RoomSelection>;
    totalExpSelected: 0;
    totalExpCost: 0;

    isRuoOpen: Boolean = false;

    totalFacilities: Number = 0;
    top5Facilities: Array<FacilityTop>;
    topFacilitiesVilla: Array<FacilityTop>;

    isVilla: Boolean = false;

    roomExpTotalSelected: Map<String, Number>;

    constructor(private resultsContainer: ResultsContainer,
        private route: ActivatedRoute, private router: Router, private spinner: NgxSpinnerService,
        private resultService: ResultsService, private sharedContainer: SharedContainer,
        private angulartics2: Angulartics2, private meta: Meta, public overlay: Overlay, public viewContainerRef: ViewContainerRef) {
        this.roomOffers = new Array<RoomInfo>();
        this.route.queryParams
            .subscribe(params => {
                if (params.checkInDate && params.checkOutDate && params.adults < 100 && params.children) {
                    this.fillRequestForSearchFromParams(params);
                } else {
                    this.router.navigate(['../']);
                }
            });
        this.config = {
            pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            spaceBetween: 0,
            on: {
                slideChangeTransitionEnd: () => {
                    this.swiperRealIndex = this.usefulSwiperMobile.swiper.activeIndex + 1;
                    // this.usefulSwiperMobile.swiper.setTranslate = -375;
                }
            }
        };
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (!this.ruoOverview.nativeElement.contains(event.target)) {
            if (this.isRuoOpen) {
                this.isRuoOpen = false;
            }
        }
    }

    ngOnInit() {
        this.roomExpTotalSelected = new Map<String, Number>();
        this.totalExpSelected = 0;
        this.totalExpCost = 0;
        this.selections = new Array<RoomSelection>();
        this.top5Facilities = new Array<FacilityTop>();
        this.topFacilitiesVilla = new Array<FacilityTop>();
        this.totalSatisfied = 0;
        this.satisfiedWishes = new Map<Number, String>();
        this.selectedExps = new Map<Number, String>();
        this.resultsContainer.changeHeader('SingleHotel');
        this.resultsContainer.playAnimation = false;
        this.offerId = this.route.pathFromRoot[2].snapshot.paramMap.get('hotelid');
        this.resultsContainer.offerId = this.route.pathFromRoot[2].snapshot.paramMap.get('hotelid');
        this.resultsContainer.currentTotalCost = this.currentTotalCost;
        this.spinner.show();
        this.resultsContainer.requestForSearch.hotelid = this.offerId;
        this.resultsContainer.requestForSearch.offerid = 0;
        this.resultService.getProperty(this.resultsContainer.requestForSearch).subscribe((offerInfo: any) => {
            this.offerInfo = offerInfo;
            offerInfo.hotel.hotelAccommocationTypeCollection.forEach(type => {
                if (type.accommodationType.name === 'Villas') {
                    this.isVilla = true;
                }
            });

            // if its villa* calculate and populate villa room facilities
            if (this.isVilla) {
                offerInfo.offerRooms.forEach(room => {
                    const collection = room.room.roomType.hotelRoomPropertyCollection;
                    collection.forEach(object => {
                        const roomProperty = object.roomProperty;
                        const facilityPush: FacilityTop = {
                            name: null,
                            priority: null
                        };
                        facilityPush.name = roomProperty.name;
                        facilityPush.priority = roomProperty.priority;
                        this.topFacilitiesVilla.push(facilityPush);
                    });
                });
                this.topFacilitiesVilla.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
            }

            // calculate and populate property general facilities
            this.totalFacilities = offerInfo.hotel.hotelFacilitiesCollection.length;
            for (let i = 0; i < offerInfo.hotel.hotelFacilitiesCollection.length; i++) {
                const facility = offerInfo.hotel.hotelFacilitiesCollection[i].facility;
                const facilityPush: FacilityTop = {
                    name: null,
                    priority: null
                };
                facilityPush.name = facility.name;
                facilityPush.priority = facility.priority;
                this.top5Facilities.push(facilityPush);
            }
            this.top5Facilities.sort((a, b) => (a.priority > b.priority) ? 1 : -1);

            // add villa room facilities to top facilities if its villa and
            // villa general facilities < 5
            if (this.isVilla) {
                this.top5Facilities = this.top5Facilities.concat(this.topFacilitiesVilla);
                this.totalFacilities = this.top5Facilities.length;
                this.topFacilitiesVilla.sort((a, b) => (a.priority > b.priority) ? -1 : 1);
            }


            this.resultsContainer.offerInfo = offerInfo;
            this.resultsContainer.requestForSearch.offerid = offerInfo.offer.id;
            this.resultsContainer.fillRequestInfoNew(this.resultsContainer.requestForSearch);

            try {
                if (offerInfo.offer.bidType.bidType === 'Personal') { // TODO fix in case is null
                    this.isOffer = true;
                    // expires in START
                    const now = new Date().getTime();
                    const expiry = new Date(offerInfo.offer.expiryDate).getTime();
                    const diffInMilliSeconds = Math.abs(expiry - now) / 1000;
                    // calculate days
                    const days = Math.floor(diffInMilliSeconds / 86400);
                    // calculate hours
                    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
                    // calculate minutes
                    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
                    this.expiresInDays = days.toString();
                    this.expiresInHours = hours.toString();
                    this.expiresInMinutes = minutes.toString();
                    // expires in END
                    if (offerInfo.offer.wishesSatisfied && offerInfo.offer.bookingRequest.bookingRequestExtrasCollection.length > 0) {
                        const satWishes = offerInfo.offer.wishesSatisfied.split(',');
                        for (let i = 0; i < satWishes.length; i++) {
                            for (let j = 0; j < this.experiencesMappingRest.length; j++) {
                                if (parseInt(satWishes[i], 10) === this.experiencesMappingRest[j].id) {
                                    const id = this.experiencesMappingRest[j].id;
                                    this.satisfiedWishes.set(id, this.experiencesMappingRest[j].name);
                                }
                            }
                        }
                        const requestExperiences = offerInfo.offer.bookingRequest.bookingRequestExtrasCollection;
                        for (let i = 0; i < requestExperiences.length; i++) {
                            this.selectedExps.set(parseInt(requestExperiences[i].bookingExtraCategory.id, 10),
                                requestExperiences[i].bookingExtraCategory.category);
                        }
                        setTimeout(() => {
                            this.calculateWishes();
                        }, 2000);
                    }
                } else {
                    this.isOffer = false;
                }
            } catch (err) {
                this.isOffer = false;
                console.error(err);
            }

            const contentsFb = new Array();
            this.meta.addTag({ name: 'Hotel', content: this.offerInfo.hotel.name + '- By Vervendo' });
            this.angulartics2.eventTrack.next({
                action: 'ViewContent',
                properties: {
                    content_name: this.offerInfo.hotel.name
                }
            });
            this.angulartics2.pageTrack.next({ path: '/propertyPage' });
            fbq('track', 'ViewContent', {
                content_name: this.offerInfo.hotel.name
            });

            const hotelInfo: HotelHeaderInfo = {
                title: offerInfo.hotel.name, stars: offerInfo.hotel.starRating,
                location: offerInfo.hotel.addressLine1 + ',' + offerInfo.hotel.addressCity + ',' + offerInfo.hotel.country,
                cost: 0
            };

            this.resultsContainer.setHeaderInfo(hotelInfo);
            this.hotelName = offerInfo.hotel.name;

            this.fillTabHeaderInfo(this.resultsContainer.requestForSearch.adults, this.resultsContainer.requestForSearch.children);
            offerInfo.propertyPics.map(pic => this.images.push(pic));
            if (offerInfo.propertyPics[0]) {
                offerInfo.propertyPics[0].preloaded = true;
            }

            this.hotelDscription = {
                image: offerInfo.propertyPics[0].pictureUrl,
                name: this.offerInfo.hotel.name,
                description: this.offerInfo.hotel.description,
                staffDescription: this.offerInfo.hotelStaff,
                personalDescription: this.offerInfo.hotel.personalDescription,
                languages: this.offerInfo.hotelLanguages.map(language => language.language.language)
            };

            this.offerInfo.hotel.hotelFacilitiesCollection.forEach(fac => {
                if (fac.surchargeType === 'uponrequest') {
                    fac.surchargeType = 'Upon Request';
                }
            });

            this.facilitiesTab = {
                general: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'General').map(facility =>
                        facility.facility.name + (facility.surchargeType === 'Upon Request' ? '(' + facility.surchargeType + ')' : '')
                    ),
                activities: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'Activities').map(facility => facility.facility.name),
                services: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'Services').map(facility => facility.facility.name),

            };
            if (this.offerInfo.hotelAcceptsPets) {
                this.facilitiesTab.general.push('Pets Accepted');
            } else {
                this.facilitiesTab.general.push('Pets Not Accepted');
            }
            this.locations = {
                shopping: this.fillLocationInfo('Shopping and Dining'),
                transportation: this.fillLocationInfo('Transportation'),
                nearby: this.fillLocationInfo('Near By'),
                healthCenters: this.fillLocationInfo('Health centers'),
                culture: this.fillLocationInfo('Culture'),
                landmarks: this.fillLocationInfo('Landmarks'),
                emergencyStations: this.fillLocationInfo('Emergency stations')
            };

            this.fillRoomOffers();
            this.fillMealTypes();
            this.fillHotelExtrasPeriods(offerInfo);
            this.fillMapInfo();
            this.fillExperiences(offerInfo);
            this.fillOfferNote(offerInfo);
            this.fillSelectedExperiences();
            this.loading = false;

            this.offerNote = this.offerInfo.offer.personalRequestResponse;
            if (this.offerInfo.hotelStaff) {
                if (this.offerInfo.hotelStaff[0]) {
                    this.hotelierIcon = 'data:image/png;base64,' + this.offerInfo.hotelStaff[0].picture;
                }
            }

            this.spinner.hide();

        }, (error: any) => console.log(error));

        this.resultsContainer.subscribeToBookingEvent().subscribe(res => {
            if (res) {
                // make put requests & redirect to booking page
                this.resultsContainer.createRequest(this.offerInfo, this.offerId, this.currentTotalCost);
            }
        });
        this.getNightsSafariFormatted(this.requestForSearch.fromdate, this.requestForSearch.todate);

    }

    calculateWishes() {

        this.finalWishes = new Map<String, Boolean>();
        if (this.satisfiedWishes.size > 0) {
            this.satisfiedWishes.forEach((key, value) => {

                this.selectedExps.forEach((value2: String, id2: Number) => {
                    if (value === id2) {
                        this.finalWishes.set(key, true);
                        this.totalSatisfied++;
                        this.selectedExps.delete(id2);
                    }
                });

            });
            this.selectedExps.forEach((value: String, key: Number) => {
                this.finalWishes.set(value, false);
            });
        }

    }

    fillRequestForSearchFromParams(data) {
        this.requestForSearch = {
            fromdate: data.checkInDate,
            todate: data.checkOutDate,
            rooms: data.rooms,
            adults: data.adults,
            children: data.children[0],
            hotelextras: data.experiences,
            experiencestitle: data.experiences_title,
            offset: 0,
            limit: 10,
            requestId: data.requestId
        };

        const month = new Array();
        month[0] = 'Jan';
        month[1] = 'Feb';
        month[2] = 'Mar';
        month[3] = 'Apr';
        month[4] = 'May';
        month[5] = 'Jun';
        month[6] = 'Jul';
        month[7] = 'Aug';
        month[8] = 'Sep';
        month[9] = 'Oct';
        month[10] = 'Nov';
        month[11] = 'Dec';

        this.resultsContainer.requestForSearch = this.requestForSearch;
        this.guests = parseInt(data.adults, 10) + parseInt(data.children, 10);

        const from = data.checkInDate.replace(/-/g, '/');
        const to = data.checkOutDate.replace(/-/g, '/');
        const fromDate = new Date(from);
        const toDate = new Date(to);
        const fromDateParsed = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        const toDateParsed = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());

        const fromMonth = month[fromDateParsed.getMonth()];
        const toMonth = month[toDateParsed.getMonth()];

        this.carouselDate = fromMonth + ' ' + fromDate.getDate().toString() + ' - ' + toMonth + ' ' + toDate.getDate().toString();
    }
    getAdult(): any {
        return this.resultsContainer.requestForSearch.adults;
    }
    getChildrens(): any {
        return this.resultsContainer.requestForSearch.children;
    }
    fillSelectedExperiences() {
        if (this.selectedExperiences.length > 0) { return; }

        this.offerInfo.extras.forEach(experience => {
            if (experience.optionalExtraCategory) {
                const exp = {
                    id: experience.optionalExtraCategory.id,
                    title: experience.optionalExtraCategory.category,
                    icon: experiencesIconsMapping.get(experience.optionalExtraCategory.id)
                };
                this.selectedExperiences.push(exp);
            }
        });

    }

    fillExperiences(offer) {
        // offer.offer.bookingOfferOptionalExtrasCollection.forEach(extra =>  this.experiencesList.add(extra.fkOptionalExtra.title));
    }

    fillOfferNote(offer) {
        /*if (offer.hotelStaff[0]) {
           const offernote = {
               text: offer.offer.personalRequestResponse,
               image: 'data:image/png;base64,' + offer.hotelStaff[0].picture
            };
           this.offerNote = offernote;
        }*/

        /*if (offer.offer.personalRequestResponse !== null) {
           if (offer.hotelier) {
               const offernote = {
                   text: offer.offer.personalRequestResponse,
                   image: 'data:image/png;base64,' + offer.hotelier.picture
               };
               this.offerNote = offernote;
           } else {
               const offernote = {
                   text: offer.offer.personalRequestResponse,
                   image: ''
               };
               this.offerNote = offernote;
           }
       }*/
    }

    fillHotelExtrasPeriods(offerInfo) {
        let roomTypeId = -1;

        const fromDate = this.resultsContainer.requestForSearch.fromdate;
        const toDate = this.resultsContainer.requestForSearch.todate;
        const currentDate = new Date(fromDate);
        const endDate = new Date(toDate);
        const presetDates = [];
        while (currentDate <= endDate) {
            presetDates.push(currentDate.getTime());
            currentDate.setDate(currentDate.getDate() + 1);
        }

        this.roomOffers.map(room => {
            const hotelExtrasTmp = this.offerInfo.extras;
            const hotelExtras = room.experiences;
            roomTypeId = room.roomTypeId;

            const ids = [];
            let i = 0;
            hotelExtras.map(experience => {
                if (experience.period.id === 4) {
                    ids.push(experience.id);
                    this.resultsContainer.getActivePeriodOfOptionalFacilty(experience.id, roomTypeId, fromDate, toDate)
                        .subscribe(dates => {
                            const experienceId = ids[i];
                            const calendarActiveDates: CalendarActiveDates = {
                                dates: dates,
                                color: experience.color,
                                title: experience.title
                            };
                            if (!this.experiencesDate.has(experienceId)) { this.experiencesDate.set(experienceId, calendarActiveDates); }
                            i++;
                        });
                } else {
                    const calendarActiveDates: CalendarActiveDates = {
                        dates: presetDates,
                        color: experience.color,
                        title: experience.title
                    };
                    if (!this.experiencesDate.has(experience.id)) { this.experiencesDate.set(experience.id, calendarActiveDates); }
                }
            });
        });
    }

    fillMapInfo() {
        const marker: IMarker = {
            lat: this.offerInfo.hotel.latitude,
            lng: this.offerInfo.hotel.longitude,
            label: this.offerInfo.hotel.id,
            draggable: false
        };
        let mapPrice = 0;
        this.markers.push(marker);
        this.mapCenter.latitude = this.offerInfo.hotel.latitude;
        this.mapCenter.longitude = this.offerInfo.hotel.longitude;
        this.offerInfo.offerRooms.map(room => {
            const price = room.room.offerPrice;
            const availability = room.room.offerPrice;
            if (price > 0 && availability > 0) {
                mapPrice = price;
            }
        });
        const hotelPreview: HotelPreview = {
            minPrice: mapPrice,
            title: this.offerInfo.hotel.name,
            description: '',
            pictures: this.offerInfo.propertyPics,
            stars: this.offerInfo.hotel.starRating,
            reviews: 0,
            experiences: [],
            optionaRequests: [],
            id: this.offerInfo.hotel.id,
            offerId: null,
            offerType: '',
            hotelierName: ''
        };
        if (this.offerInfo.hotelStaff) {
            if (this.offerInfo.hotelStaff.length > 0) {
                hotelPreview.hotelierName = this.offerInfo.hotelStaff[0].name;
            } else {
                hotelPreview.hotelierName = this.offerInfo.hotel.contactPerson;
            }
        }
        this.hotelierName = hotelPreview.hotelierName;
        this.hotels.push(hotelPreview);
    }

    getHotels = () => this.resultsContainer.getHotels();

    fillLocationInfo(groupName) {
        const location = new Map<string, Array<string>>();
        this.offerInfo.hotelPois
            .filter(poi => {
                return (poi.placeOfInterest.groupName === groupName);
            })
            .map(poi => {
                if (location.has(poi.placeOfInterest.name)) {
                    const loc = poi.name + ' (' + poi.distance + ' ' + poi.milesKm + ')';
                    location.get(poi.placeOfInterest.name).push(loc);
                } else {
                    const arr = new Array<string>();
                    const loc = poi.name + ' (' + poi.distance + ' ' + poi.milesKm + ')';
                    arr.push(loc);
                    location.set(poi.placeOfInterest.name, arr);
                }
            });
        return location;
    }

    compareExpreriences(a, b) {
        if (a.surchargeType === 'free' && b.surchargeType === 'define') {
            return -1;
        } else if (b.surchargeType === 'free' && a.surchargeType === 'define') {
            return 1;
        }
        return 0;
    }


    fillRoomPictures(pics) {
        if (pics == null) {
            return [];
        } else {
            return pics.map((r, index) => {
                if (index === 0) {
                    r.preloaded = true;
                    return r;
                } else {
                    return r;
                }
            });
        }
    }

    populateRoom(room1, rooms) {
        const checkinout: Checkin = {
            checkInTimeFrom: this.offerInfo.hotel.checkInTimeFrom,
            checkInTimeUntil: this.offerInfo.hotel.checkInTimeUntil,
            checkOutTimeFrom: this.offerInfo.hotel.checkOutTimeFrom,
            checkOutTimeUntil: this.offerInfo.hotel.checkOutTimeUntil
        };
        const hotelExtras: Map<number, any> = new Map();
        this.offerInfo.extras.forEach(element => {
            if (!hotelExtras.has(element.id)) {
                hotelExtras.set(element.id, element);
            }
        });
        let extras;

        if (room1.roomExtras !== null && room1.roomExtras !== undefined) {
            room1.roomExtras.forEach(element => {
                if (hotelExtras.has(element.id)) {
                    if (hotelExtras.get(element.id).surchargeAmount > element.surchargeAmount) {
                        element.was = hotelExtras.get(element.id).surchargeAmount;
                        element.discount = Math.round((1 - (element.surchargeAmount / element.was)) * 100);
                    }
                    hotelExtras.set(element.id, element);
                } else if (element.surchargeType) {
                    // only for personal or define in inventory or define in room settings
                    // if (hotelExtras.get(element.id).surchargeAmount > room1.roomExtras.surchargeAmount) {
                    //    element.was = parseFloat(element.surchargeType) || element.surchargeAmount;
                    // }
                    const was = parseFloat(element.surchargeType) || element.surchargeAmount;
                    if (was !== element.surchargeAmount) {
                        element.was = was;
                        element.discount = Math.round((1 - (element.surchargeAmount / element.was)) * 100);
                    }
                    hotelExtras.set(element.id, element);

                } else {
                    hotelExtras.set(element.id, element);
                }
            });
            extras = Array.from(hotelExtras.values()).sort(this.compareExpreriences);
        } else {
            extras = this.offerInfo.extras;
        }
        const room = room1.room;

        let withCancellationPrice: number;
        let withCancellationOfferPrice: number;
        let withCancellationPricingPolicy;
        let withCancellationID: number;

        let nonRefundablePrice: number;
        let nonRefundableOfferPrice: number;
        let nonRefundablePricingPolicy;
        let nonRefundableID: number;
        const roomFound = rooms.find(r => r.room.roomType.name === room.roomType.name && r.room.id !== room.id);

        if (roomFound && this.roomOffers.find(r => r.title === roomFound.room.roomType.name) !== undefined) { return null; }

        let roomMode: RoomMode;
        if (room.cancellationPolicy.nonRefundable) {
            nonRefundablePrice = room.nonRefundablePrice;
            nonRefundableOfferPrice = room.offerPrice;
            nonRefundablePricingPolicy = this.fillPricingPolicy(room);
            nonRefundableID = room.id;
            roomMode = RoomMode.NON_REFUNDABLE;

            if (roomFound && !this.roomOffers.find(r => r.title === roomFound.room.roomType.name)) {
                withCancellationPrice = roomFound.room.defaultPrice;
                withCancellationOfferPrice = roomFound.room.offerPrice;
                withCancellationPricingPolicy = this.fillPricingPolicy(roomFound.room);
                withCancellationID = roomFound.room.id;
                roomMode = RoomMode.BOTH;
            }

        } else if (!room.cancellationPolicy.nonRefundable) {
            if (roomFound) {
                nonRefundablePrice = roomFound.room.defaultPrice;
                nonRefundableOfferPrice = roomFound.room.offerPrice;
                nonRefundablePricingPolicy = this.fillPricingPolicy(roomFound.room);
                nonRefundableID = roomFound.room.id;
                roomMode = RoomMode.WITH_CANCELLATION;
            }

            if (!this.roomOffers.find(r => r.title === room.roomType.name)) {
                withCancellationPrice = room.defaultPrice;
                withCancellationOfferPrice = room.offerPrice;
                withCancellationPricingPolicy = this.fillPricingPolicy(room);
                withCancellationID = room.id;
                roomMode = RoomMode.BOTH;
            }
        }

        const roomInfo: RoomInfo = {
            title: room.roomType.name,
            roomSize: room.roomType.roomSurfaceArea,
            bathrooms: !isNaN(room.roomType.wcType.wcType) ? room.roomType.wcType.wcType : 1,
            sleepingSpaces: room.roomType.hotelRoomTypeSpaceCollection.length,
            sleepingSpacesDetails: room.roomType.hotelRoomTypeSpaceCollection,
            maxPeople: room.roomType.capacity,
            pictures: this.fillRoomPictures(room1.roomTypePics),
            experiences: extras.filter(extra => extra.hotelMeal === null),
            description: room.roomType.description,
            roomFacilities: room.roomType.hotelRoomPropertyCollection,
            meals: this.createMealItems(extras.filter(extra => extra.hotelMeal !== null).concat(this.offerInfo.meals)),
            handicapAccess: room.roomType.handicapAccess,
            smokingRoom: room.roomType.smokingRoom,
            liftorStairs: room.roomType.liftOrStairs,
            bedTypes: room.roomType.hotelRoomTypeSpaceCollection
                .map(space => space.hotelRoomTypeSpaceBedsCollection
                    .map(bedType => bedType.bedType.name)),
            checkin: checkinout,
            roomType: room.roomType.roomType.roomType,
            roomTypeId: room.roomType.id,

            withCancellationPrice: withCancellationPrice,
            withCancellationOfferPrice: withCancellationOfferPrice,
            withCancellationPricingPolicy: withCancellationPricingPolicy,
            withCancellationID: withCancellationID,
            nonRefundablePrice: nonRefundablePrice,
            nonRefundableOfferPrice: nonRefundableOfferPrice,
            nonRefundablePricingPolicy: nonRefundablePricingPolicy,
            nonRefundableID: nonRefundableID,

            roomMode: roomMode,
            availability: room.availableRooms,
            available: !room.stopSales,

            cancellationPolicy: room.cancellationPolicy,

            useOnlyName: room.roomType.useOnlyName
        };
        return roomInfo;
    }

    fillRoomOffers() {
        let rooms = new Array();

        rooms = this.offerInfo.offerRooms;


        rooms.forEach(room => {
            let roomInfo;
            roomInfo = this.populateRoom(room, rooms);
            if (roomInfo != null) {
                this.roomOffers.push(roomInfo);
            }
        });



        this.roomOffers.sort((a, b) => Math.min(a.withCancellationOfferPrice, a.nonRefundableOfferPrice) -
            Math.min(b.withCancellationOfferPrice, a.nonRefundableOfferPrice));

        this.roomOffers.forEach(room => {
            const oldPrice = room.withCancellationPrice;
            const newPrice = room.withCancellationOfferPrice;
            const discount = ((oldPrice - newPrice) / oldPrice) * 100;
            if (newPrice < oldPrice) {
                this.bestDiscount.oldPrice = oldPrice;
                this.bestDiscount.newPrice = newPrice;
                this.bestDiscount.discount = discount;
                this.bestDiscount.discountUp = true;
            } else if (newPrice > oldPrice) {
                this.bestDiscount.oldPrice = oldPrice;
                this.bestDiscount.newPrice = newPrice;
                this.bestDiscount.discount = discount * (-1);
                this.bestDiscount.discountUp = false;
            }
        });
    }

    createMealItems(meals) {
        const finalMeals = new Array();
        meals.forEach(meal => {
            if (meal.hotelMeal === null || meal.hotelMeal === undefined) {
                const m = {
                    id: meal.id,
                    title: meal.mealType.mealType,
                    surchargeAmount: meal.surchargeAmount,
                    surchargeUnit: meal.surchargeUnit.surchargeUnit,
                    description: ''
                };
                finalMeals.push(m);
            } else {
                const m = {
                    id: meal.id,
                    title: meal.hotelMeal.mealType.mealType,
                    surchargeAmount: meal.surchargeAmount,
                    surchargeUnit: meal.hotelMeal.mealType.surchargeUnit.surchargeUnit,
                    hasImage: meal.hasImage,
                    description: meal.description
                };
                finalMeals.push(m);
            }
        });
        return finalMeals;

    }

    fillMealTypes() {
        this.roomOffers.forEach(room => {
            room.meals.forEach(meal => {
                this.mealtypes.add(meal.title);
            });
        });
    }


    fillPricingPolicy(offerRoom) {
        const cancellationPolicy = offerRoom.cancellationPolicy;

        let cancellationTitle = '';
        let alternativeTitle = '';
        const cancellationText = new Array<string>();
        if (offerRoom.originalId && offerRoom.cancellationPolicy.freeCancellation === false) {
            cancellationTitle = 'Non Refundable';
            alternativeTitle = 'No Refund on Cancellation';
        } else if (cancellationPolicy.freeCancellation) {
            cancellationTitle = 'Free Cancellation';
            alternativeTitle = 'Free Cancellation';
        } else if (cancellationPolicy.nonRefundable) {
            cancellationTitle = 'Non Refundable';
            alternativeTitle = 'No Refund on Cancellation';
        } else {
            cancellationTitle = 'With Cancellation';
            const pricingPolicyy = offerRoom.pricingPolicy;
            cancellationText.push(pricingPolicyy.depositPercent + '% Deposit');
            cancellationText.push(cancellationPolicy.noShow + '% No-show');

            cancellationPolicy.hotelCancellationPolicyDaysCollection.map(policyDays => {
                cancellationText.push(policyDays.feePercent + '% Cancellation fee prior to ' + policyDays.daysLessThan + ' days');
            });
        }

        if (cancellationText.length === 0) {
            const pricingPolicyy = offerRoom.pricingPolicy;
            cancellationText.push(pricingPolicyy.depositPercent + '% Deposit');
            cancellationText.push(cancellationPolicy.noShow + '% No-show');
            cancellationText.push(alternativeTitle);
        }

        const childrenOffers = new Array<string>();
        this.offerInfo.childrenOfferType.map(childrenType => {
            if (childrenType.applyDiscount) {
                childrenOffers.push('Free! All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + (childrenType.childrenMaxAge !== 1) ? 's' : '' +
                ' stay free of charge for children\'s cots/cribs.');
            } else {
                const sornot = (childrenType.childrenMaxAge !== 1) ? 's' : '';
                childrenOffers.push('All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + sornot +
                    ' have ' + childrenType.hotelAutomatedOfferChildrenTypeDiscountCollection[0].discountPercentage +
                    ' for children\'s cots/cribs.');
            }
        });

        const pricingPolicy: PricingPolicy = {
            title: cancellationTitle,
            alternativeTitle: alternativeTitle,
            titleTooltip: cancellationText,
            cancelationPrepayment: cancellationText,
            childrenOffers: childrenOffers
        };
        return pricingPolicy;
    }

    fillTabHeaderInfo(noOfAdults, noOfChildren) {
        const roomPeople = {
            rooms: this.resultsContainer.myRequestInfo.rooms,
            adults: noOfAdults,
            children: noOfChildren
        };

        this.tabHeaderInfo = {
            checkin: this.formatDate(new Date(this.resultsContainer.myRequestInfo.fromdate)),
            checkout: this.formatDate(new Date(this.resultsContainer.myRequestInfo.todate)),
            numberOfNights: this.getNights(
                this.resultsContainer.myRequestInfo.fromdate,
                this.resultsContainer.myRequestInfo.todate
            ),
            roomPeople: roomPeople,
            numberOfNightsSafari: this.getNightsSafari(this.resultsContainer.myRequestInfo.fromdate,
                this.resultsContainer.myRequestInfo.todate)
        };
    }

    getNights(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    getNightsSafari(from, to) {
        const fromDate = from.replace(/-/g, '/');
        const toDate = to.replace(/-/g, '/');
        const date1 = new Date(fromDate);
        const date2 = new Date(toDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    scrollToAmentities() {
        const el = document.getElementById('amentities');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('amentities').scrollTop += 40;
    }

    scrollToDetails() {
        const el = document.getElementById('details');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('details').scrollTop += 40;
    }

    scrollToLocation() {
        const el = document.getElementById('location');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('location').scrollTop += 40;
    }

    scrollToRooms() {

        const el = document.getElementById('rooom-title');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('rooom-title').scrollTop += 40;
    }

    formatDate(date) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const dayNames = [
            'Sunday', 'Monday', 'Tuesday',
            'Thursday', 'Wednesday', 'Friday', 'Saturday'];

        const day = date.getDate();
        const weekDay = date.getDay();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return dayNames[weekDay] + ', ' + day + ' ' + monthNames[monthIndex] + ' ' + year;
    }

    selectMeal(data) {
        let totalCost = 0;
        this.roomsForBooking = data[0];
        this.resultsContainer.roomsForBooking = data[0];
        data[0].forEach((info, key, map) => {
            map.forEach((one, two) => {
                const selection: RoomSelection = {
                    name: one.title,
                    count: one.selectedRooms,
                    cost: one.roomCost,
                    id: parseInt(two, 10)
                };
                if (!this.selections.some(e => e.id === parseInt(two, 10))) {
                    this.selections.push(selection);
                } else {
                    // const index = this.selections.findIndex((element) => element.id === parseInt(key, 10));
                    // this.selections.splice(index, 1);
                    // this.selections.push(selection);
                }
            });
            if (info.experienceTitleCost) {
                info.experienceTitleCost.forEach((num, name) => {
                    if (parseInt(num, 10) === 0) {
                        this.roomExpTotalSelected.delete(name);
                    } else {
                        this.roomExpTotalSelected.set(name, num);
                    }
                });
            }
            totalCost += info.roomCost;
            info.experienceTypes.forEach((costInfo, key1, map1) => {
                totalCost += (costInfo.costPerItem * costInfo.quantity);
                map1.forEach((k, v) => {
                    this.totalExpSelected += parseInt(k.quantity, 10);
                    this.totalExpCost += parseInt(k.quantity, 10) * parseInt(k.costPerItem, 10);
                });
            });
            info.roomMealTypes.forEach((costInfo, key1, map1) => {
                totalCost += (costInfo.costPerItem * costInfo.quantity);
            });
            const index1 = this.roomOffers.map(roomOffer => roomOffer.withCancellationID).indexOf(key);
            const index2 = this.roomOffers.map(roomOffer => roomOffer.nonRefundableID).indexOf(key);
            if (index2 > -1) {
                this.selectedRoomTypes.set(key, this.roomOffers[index2].roomType);
            } else if (index1 > -1) {
                this.selectedRoomTypes.set(key, this.roomOffers[index1].roomType);
            }
        });

        // Remove rooms that are not selected anymore
        this.selectedRoomTypes.forEach((info, key, map) => {
            if (!data[0].has(key)) {
                this.selectedRoomTypes.delete(key);
                const index = this.selections.findIndex((element) => element.id === parseInt(key, 10));
                this.selections.splice(index, 1);
            }
        });
        this.currentTotalCost = totalCost;
        this.resultsContainer.currentTotalCost = this.currentTotalCost;
        this.hotelInfo = {
            title: this.offerInfo.hotel.name, stars: this.offerInfo.hotel.starRating,
            location: this.offerInfo.hotel.addressLine1 + ',' + this.offerInfo.hotel.addressCity + ',' + this.offerInfo.hotel.country,
            cost: totalCost
        };
        this.resultsContainer.setHeaderInfo(this.hotelInfo);
    }



    bookNow(data) {
        if (this.isUserLoggedIn()) {
            this.resultsContainer.requestForSearch.totalprice = this.currentTotalCost;
            this.resultsContainer.fillRequestInfoNew(this.resultsContainer.requestForSearch);
            this.sharedContainer.generalState$.dispatch(new ChangeLasteRequestAsked(1,
                { lastRequestAsked: this.resultsContainer.myRequestInfo }));
            this.resultsContainer.goToBooking(this.offerInfo, this.offerId, this.currentTotalCost);
        } else {
            this.resultsContainer.roomsForBooking = this.roomsForBooking;
            this.resultsContainer.openLoginModal();
        }
    }

    isUserLoggedIn() {
        return this.sharedContainer.isLoggedIn$;
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    getAdults() {
        return this.offerInfo.bookingRequest.roompersons.reduce((sum, current) => (sum + parseInt(current.adults, 10)), 0);
    }

    getChildren() {
        return this.offerInfo.bookingRequest.roompersons.reduce((sum, current) => (sum + current.children.length), 0);
    }

    getNightsSafariFormatted(from, to) {
        from = from.replace(/-/g, '/');
        to = to.replace(/-/g, '/');
        const date1 = new Date(from);
        const date2 = new Date(to);
        this.formattedFromDate = this.getFormatedDate(date1);
        this.formattedToDate = this.getFormatedDate(date2);
    }

    getFormatedDate(date) {
        const selectedDate = new Date(date);
        return (selectedDate.getDate() + '/'
            + (selectedDate.getMonth() + 1) + '/'
            + selectedDate.getFullYear());
    }

    onSlidePropertyPics({ prev, current, direction }) {
        if (this.offerInfo.propertyPics[current]) {
            this.offerInfo.propertyPics[current].preloaded = true;
        }
        if (this.offerInfo.propertyPics[current + 1]) {
            this.offerInfo.propertyPics[current + 1].preloaded = true;
        }
    }

    onSlideHotelPics({ prev, current, direction }) {
        if (this.offerInfo.pictures[current]) {
            this.offerInfo.pictures[current].preloaded = true;
        }
        if (this.offerInfo.pictures[current + 1]) {
            this.offerInfo.pictures[current + 1].preloaded = true;
        }
    }


    openMapWindow() {
        document.getElementById('right').style.width = '100%';
        document.getElementById('total-book').style.visibility = 'hidden';
        this.mobileFullsreenWindow.isMapOpen = true;
    }

    openMapWindowDesktop() {
        if (this.isMapDesktopOpen) {
            this.isMapDesktopOpen = false;
        } else {
            this.isMapDesktopOpen = true;
        }
    }

    closeFilterWindow() {
        this.mobileFullsreenWindow.isMapOpen = false;
        document.getElementById('right').style.width = '0';
        document.getElementById('total-book').style.visibility = 'visible';
    }

    isMapReady() {
        if (this.resultsContainer.getMapCenter().latitude !== 0) { return true; }
    }

    readMore() {

        const dots = document.getElementById('dots');
        const moreText = document.getElementById('more');
        const btnText = document.getElementById('myBtn');

        if (dots.style.display === 'none') {
            dots.style.display = 'inline';
            btnText.innerHTML = 'Read more';
            moreText.style.display = 'none';
        } else {
            dots.style.display = 'none';
            btnText.innerHTML = 'Read less';
            moreText.style.display = 'inline';
        }
    }

    highlightText(event) {
        this.isTextHighlighted = event;
    }

    requestUniqueOffer() {
        this.spinner.show();
        this.resultService.requestUniqueOffer(this.hotelName, this.requestForSearch.requestId).subscribe(response => {
            if (response === 0) {
                this.spinner.hide();
                Swal.fire('Your request was successfully sent');
            } else {
                this.spinner.hide();
                Swal.fire('Oops. Something went wrong. Please try again in a while');
            }
        });
        setTimeout(() => {
            this.spinner.hide();
        }, 10000);
    }


    goBack() {
        window.history.back();
    }

}

export interface TabHeaderInfo {
    roomPeople;
    checkin: string;
    checkout: string;
    numberOfNights: number;
    numberOfNightsSafari: number;
}

export interface HotelDescription {
    image: string;
    name: string;
    description: string;
    staffDescription: Array<string>;
    languages: Array<string>;
    personalDescription: string;
}

export interface FacilitiesTabInfo {
    general: Array<string>;
    activities: Array<string>;
    services: Array<string>;
}

export interface LocationTabInfo {
    shopping: Map<string, Array<string>>;
    transportation: Map<string, Array<string>>;
    nearby: Map<string, Array<string>>;
    healthCenters: Map<string, Array<string>>;
    culture: Map<string, Array<string>>;
    landmarks: Map<string, Array<string>>;
    emergencyStations: Map<string, Array<string>>;
}

export interface RoomInfo {
    title: string;
    roomSize: string;
    bathrooms: number;
    sleepingSpaces: number;
    sleepingSpacesDetails: Array<any>;
    maxPeople: number;
    pictures: Array<any>;
    experiences: Array<any>;
    description: string;
    roomFacilities: Array<string>;
    meals: Array<any>;
    handicapAccess: boolean;
    smokingRoom: string;
    liftorStairs: string;
    bedTypes: Array<string>;
    checkin: Checkin;
    roomType: string;
    roomTypeId: number;

    withCancellationPrice: number;
    withCancellationOfferPrice: number;
    withCancellationPricingPolicy;
    withCancellationID: number;

    nonRefundablePrice: number;
    nonRefundableOfferPrice: number;
    nonRefundablePricingPolicy;
    nonRefundableID: number;

    roomMode: RoomMode;

    availability: number;
    available: boolean;

    cancellationPolicy: CancellationPolicy;

    useOnlyName: boolean;
}


export interface Checkin {
    checkInTimeFrom;
    checkInTimeUntil;
    checkOutTimeFrom;
    checkOutTimeUntil;
}

export interface PricingPolicy {
    title: string;
    alternativeTitle: string;
    titleTooltip: Array<string>;
    cancelationPrepayment: Array<string>;
    childrenOffers: Array<string>;
}

export interface CalendarActiveDates {
    dates: Array<number>;
    color: string;
    title: string;
}

export interface FacilityTop {
    name: string;
    priority: number;
}

export interface RoomSelection {
    name: String;
    count: Number;
    cost: Number;
    id: Number;
}
